// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.alert[data-v-2034258e] {

    margin-bottom: 2.5rem;

    display: flex;

    gap: 0.75rem;

    padding: 1rem
}
.alert--success[data-v-2034258e] {

    --tw-bg-opacity: 1;

    background-color: rgb(236 253 245 / var(--tw-bg-opacity));

    --tw-text-opacity: 1;

    color: rgb(12 193 117 / var(--tw-text-opacity))
}
.alert--warning[data-v-2034258e] {

    --tw-bg-opacity: 1;

    background-color: rgb(255 251 235 / var(--tw-bg-opacity));

    --tw-text-opacity: 1;

    color: rgb(224 176 8 / var(--tw-text-opacity))
}
.alert--envelope[data-v-2034258e] {

    --tw-bg-opacity: 1;

    background-color: rgb(255 235 200 / var(--tw-bg-opacity));

    --tw-text-opacity: 1;

    color: rgb(22 22 22 / var(--tw-text-opacity))
}
@media (min-width: 768px) {
.alert--envelope[data-v-2034258e] {

        padding-top: 1.5rem;

        padding-bottom: 1.5rem
}
}
.alert--error[data-v-2034258e] {

    --tw-bg-opacity: 1;

    background-color: rgb(255 178 157 / var(--tw-bg-opacity));

    --tw-text-opacity: 1;

    color: rgb(216 0 3 / var(--tw-text-opacity))
}
.alert--info[data-v-2034258e] {

    --tw-bg-opacity: 1;

    background-color: rgb(209 230 237 / var(--tw-bg-opacity));

    --tw-text-opacity: 1;

    color: rgb(0 158 208 / var(--tw-text-opacity))
}
.alert__title[data-v-2034258e] {

    margin-bottom: 1.5rem;

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
.alert__subtitle[data-v-2034258e] {

    margin-bottom: 0.5rem;

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
.alert__message[data-v-2034258e] {

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
.alert__messages[data-v-2034258e] {

    margin-left: 1rem;

    list-style-type: disc
}
.alert__messages[data-v-2034258e] > :not([hidden]) ~ :not([hidden]) {

    --tw-space-y-reverse: 0;

    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));

    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse))
}
.alert__item[data-v-2034258e] {

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
.alert__thanks[data-v-2034258e] {

    margin-top: 1.5rem
}
.alert__thanks[data-v-2034258e] > :not([hidden]) ~ :not([hidden]) {

    --tw-space-y-reverse: 0;

    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));

    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse))
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/alerts/Alert.vue"],"names":[],"mappings":";AAgEA;;IAAA,qBAAA;;IAAA,aAAA;;IAAA,YAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAIA;;IAAA,qBAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAGA;;IAAA,qBAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAGA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAGA;;IAAA,iBAAA;;IAAA;AAAA;AAAA;;IAAA,uBAAA;;IAAA,+DAAA;;IAAA;AAAA;AAGA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAAA;;IAAA,uBAAA;;IAAA,+DAAA;;IAAA;AAAA","sourcesContent":["<template>\n  <div class=\"alert\" :class=\"`alert--${type}`\">\n    <div class=\"alert__icon\">\n      <Icon :name=\"type\" :size=\"20\" :color=\"color\" :type=\"iconStyle\" />\n    </div>\n    <div class=\"alert__content\">\n      <p v-if=\"title\" class=\"alert__title\">{{ title }}</p>\n      <p v-if=\"subtitle\" class=\"alert__subtitle\">{{ subtitle }}</p>\n      <p v-if=\"typeof content === 'string'\" class=\"alert__message\">{{ content }}</p>\n      <div v-else>\n        <ul class=\"alert__messages\">\n          <li v-for=\"message in content\" v-bind:key=\"message\" class=\"alert__item\">{{ message }}</li>\n        </ul>\n        <div v-if=\"showThanks\" class=\"alert__thanks\">\n          <p class=\"alert__item\">Comenzaremos a trabajar en tu solicitud a la brevedad.</p>\n          <p class=\"alert__item\">¡Gracias por contactar con nosotros!</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport Icon from '@/lego/components/icons/Icon.vue';\n\nexport default {\n  components: {\n    Icon,\n  },\n  props: {\n    type: {\n      type: String,\n      default: 'success',\n    },\n    title: {\n      type: String,\n      default: null,\n    },\n    subtitle: {\n      type: String,\n      default: null,\n    },\n    content: {\n      type: [String, Array],\n      default: null,\n    },\n    showThanks: {\n      type: Boolean,\n      default: false,\n    },\n    color: {\n      type: String,\n      default: 'transparent',\n    },\n    iconStyle: {\n      type: String,\n      default: 'solid',\n    },\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.alert {\n  @apply p-xxxs mb-sm flex gap-micro;\n\n  &--success {\n    @apply bg-feedback-success-lightest text-feedback-success-medium;\n  }\n  &--warning {\n    @apply bg-feedback-alert-lightest text-feedback-alert-dark;\n  }\n  &--envelope {\n    @apply bg-feedback-alert-soft text-neutral-superdark md:py-xxs;\n  }\n  &--error {\n    @apply bg-feedback-error-lightest text-feedback-error-medium;\n  }\n  &--info {\n    @apply bg-feedback-info-light text-feedback-info-dark;\n  }\n\n  &__title {\n    @apply style-overline mb-xxs;\n  }\n  &__subtitle {\n    @apply style-overline mb-nano;\n  }\n  &__message {\n    @apply style-overline;\n  }\n  &__messages {\n    @apply list-disc ml-xxxs space-y-quark;\n  }\n  &__item {\n    @apply style-overline;\n  }\n  &__thanks {\n    @apply mt-xxs space-y-quark;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
